(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('HeaderController', HeaderController);

    HeaderController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function HeaderController ($state, Auth, Principal, ProfileService, LoginService, $translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.selectLanguage = selectLanguage;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        /*
        To forgetful Albert: just in case you forgot why you did it this way, here's why --
        key - used to get flag icon. Must be in accordance to smartadmin-production.min.css
        jhiKey - used for translating the whole app. check contents of vm.jhiLanguages to get key for other languages
        alt - Just the alternate text for link
        title - what will show up on the front end
         */
        vm.lang = [
            {
                "key": "us",
                "jhiKey": "en",
                "alt": "English",
                "title": "English (US)"
            },
            {
                "key": "jp",
                "jhiKey": "ja",
                "alt": "Japanese",
                "title": "日本語"
            },
            {
                "key": "pt",
                "jhiKey": "pt-br",
                "alt": "Portuguese",
                "title": "Português"
            }
        ];
        // set default language
        vm.currentLanguage = vm.lang[0];
        
        // insert JSON object to iterate on front end
        vm.languages = vm.lang;
        
        // for translating stuff
        vm.jhiLanguages = null;
        JhiLanguageService.getAll().then(function (languages) {
            vm.jhiLanguages = languages;
        });
        
        function selectLanguage( language ) {
            //update current Language that will show up on front end
            vm.currentLanguage = language;
            //translate the whole app
            $translate.use( language.jhiKey );
            tmhDynamicLocale.set( language.jhiKey );
        }
    }
})();
